(function(){
    'use strict';

/**
* @memberof app
* @ngdoc controller
* @name VideosMultController
* @description
* This is main controller
**/ 

    angular
    .module('app')
    .controller('VideosMultController', VideosMultController);

    VideosMultController.$inject = ["VideosMultService","$timeout","$location",'$anchorScroll','$uibModal'];

    function VideosMultController(VideosMultService,$timeout,$location,$anchorScroll,$uibModal)
    {
    	var vm = this;
        vm.pag = 0;
        vm.maxPages = 0;
        vm.categoria_id = {};
        vm.buscador = "";
        vm.videos = [];
		    vm.modalVid = "";
        //console.log(window.location.pathname);
        //console.log();

        vm.getHashUrl = function(callback){
            var hash = location.hash.split("/");
            if(typeof(hash[1]) != 'undefined' && hash[1]!=''){
                //console.log(hash);
                VideosMultService.getVideoById(hash[1],function(data){
                    //console.log(hash[1]);
                    if(typeof(callback) != 'undefined'){
                        callback(data);
                        
                    }
                });
            }
        }
        


        vm.loading = false;
        vm.getVideosMult = function(init,callback){
            vm.loading = true;
            VideosMultService.getVideosMult(vm,function(data){
                vm.loading = false;
                vm.videos = data.videos;
                vm.maxPages = data.maxPages;
                vm.items = data.items;
                if(vm.pag>0){
                    $("html, body").animate({ scrollTop: $('.filters-news').offset().top }, 1000);
                }
                if(init==0){
                    vm.getHashUrl(function(datap){
                        console.log(data);
                        vm.pag = datap.page;
                        vm.mostrarPop(datap.video,datap.index);
                    });
                }
                if(typeof(callback) != 'undefined'){
                    callback();
                }

                //console.log(vm.maxPages );
            },function(){vm.loading = false;});
        };

        vm.getUrlVimeo = function(video){
            //console.log("https://player.vimeo.com/video/"+video.vimeo);
            return "https://player.vimeo.com/video/"+video.vimeo;
        };

 		
        vm.mostrarPop = function(video,index){
            console.log(index +" index");
        	vm.modalVid = $uibModal.open({
	          animation: true,
	          ariaLabelledBy: 'modal-title-top',
	          ariaDescribedBy: 'modal-body-top',
	          templateUrl: 'popvid.html',
	          size: 'lg',
	          backdrop:'static',
	          controller: function($scope) {
                  //console.log(video);
	              $scope.video = video;
                  $scope.index = index;
                  $scope.pag = vm.pag;
                  $scope.maxPages = vm.maxPages;

                  $scope.items = vm.items;
                  $location.path('/'+video.id); 
                  //$location.hash(video.id); 

                  $scope.getUrlVimeo = function(vid){
                      //console.log("popup");
                    return vm.getUrlVimeo(vid);
                  }
	             
	            $scope.okForm = function(){
	                vm.modalVid.close();
                  $location.path(''); 
	            }





                $scope.siguiente = function(){
                      if(vm.items-1 >= $scope.index+1){
                          if(typeof(vm.videos[$scope.index+1]) == 'undefined'){
                              console.log("next");
                              vm.next(function(){
                              console.log("finnext");
                                  $scope.video = vm.videos[0];
                                  $scope.pag = vm.pag;
                                  $scope.index = 0;
                                  console.log($scope);
                                  $location.path('/'+$scope.video.id); 
                              });
                          }else{
                              $scope.video = vm.videos[$scope.index+1];
                              $scope.index++;
                              $location.path('/'+$scope.video.id); 
                          }
                      }
                  };

                  $scope.anterior = function(){
                      if($scope.index-1 >= 0 || vm.pag > 0){
                          if(typeof(vm.videos[$scope.index - 1]) == 'undefined'){
                              vm.prev(function(){
                                  $scope.video = vm.videos[11];
                                  $scope.pag = vm.pag;
                                  $scope.index = 11;
                                  $location.path('/'+$scope.video.id); 
                              });
                          }else{
                              $scope.video = vm.videos[$scope.index - 1];
                              $scope.index--;
                              $location.path('/'+$scope.video.id); 
                          }
                      }
                  };
	           
	          },
              resolve: {
                item: function () {
                    console.log("resolve");
                    

                  //return $stateParams.id
                }
              }
	      	});

        }

       vm.next = function(callback){
            vm.pag++;
            vm.getVideosMult(1,callback);
        };

        vm.prev = function(callback){
            vm.pag--;
            vm.getVideosMult(1,callback);
        };


    }


})();